import {first} from 'lodash';
import React, {FC, useCallback, useEffect, useState} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {useLayer} from '../../../../../libs/shared/ui/src/components/layers/layerContext';
import {ActivityModel} from '../../../../models/api/activityModel';
import {UnreadBannerBase, UnreadBannerPositionsEnum} from './unreadBannerBase';

/*
 * Props.
 */

interface UnreadBannerAboveProps {
  unreadActivitiesAbove: ReadonlyArray<ActivityModel>;
  setReadActivityIds: (computeReadActivityIds: (prevReadActivityIds: Array<string>) => Array<string>) => void;
  onUnreadBannerClick: (arg: number | undefined) => void;
}

/*
 * Component.
 */

export const UnreadBannerAbove: FC<UnreadBannerAboveProps> = (props) => {
  const {unreadActivitiesAbove, setReadActivityIds, onUnreadBannerClick} = props;

  const hasUnreadActivitiesAbove = unreadActivitiesAbove.length !== 0;

  const [isVisibleDelayed, setIsVisibleDelayed] = useState(hasUnreadActivitiesAbove);

  const onDismissUnreadBanner = useCallback(() => {
    setReadActivityIds((prevReadActivityIds) => [
      ...new Set([...prevReadActivityIds, ...unreadActivitiesAbove.map((activity) => `${activity.id}`)]),
    ]);
  }, [unreadActivitiesAbove, setReadActivityIds]);

  const onNavigateToUnread = useCallback(() => {
    const firstUnreadActivity = first(unreadActivitiesAbove);
    onUnreadBannerClick(firstUnreadActivity?.id);
    onDismissUnreadBanner();
  }, [unreadActivitiesAbove, onDismissUnreadBanner]);

  const {window} = useLayer();

  useEffect(() => {
    const handle = window.setInstrumentedTimeout(() => setIsVisibleDelayed(hasUnreadActivitiesAbove), 1000);
    return () => window.clearTimeout(handle);
  }, [hasUnreadActivitiesAbove]);

  if (!isVisibleDelayed || !hasUnreadActivitiesAbove) {
    return null;
  }

  return (
    <UnreadBannerBase
      currentPosition={UnreadBannerPositionsEnum.TOP}
      label={<Trans id="unread-banner-above-newestunread">{unreadActivitiesAbove.length} unread</Trans>}
      onNavigateToUnreadClick={onNavigateToUnread}
      onDismissBannerClick={onDismissUnreadBanner}
    />
  );
};
